/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const YahooIconConfig = {
  name: 'YahooIcon',
  height: 512,
  width: 448,
  svgPath: 'M252 292l4 220c-12.7-2.2-23.5-3.9-32.3-3.9-8.4 0-19.2 1.7-32.3 3.9l4-220C140.4 197.2 85 95.2 21.4 0c11.9 3.1 23 3.9 33.2 3.9 9 0 20.4-.8 34.1-3.9 40.9 72.2 82.1 138.7 135 225.5C261 163.9 314.8 81.4 358.6 0c11.1 2.9 22 3.9 32.9 3.9 11.5 0 23.2-1 35-3.9C392.1 47.9 294.9 216.9 252 292z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(YahooIconConfig);